import React, {useState} from 'react';
import {useTecRmi} from "../../contexts/TecRmiContext";
import useDidMountEffect from "../../utils/useDidMountEffect";
import apiUser from "../../apiUser";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import AppTable from "../../componentsReusable/AppTable";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import appUserRoutes from "../../appUserRoutes";
import {TAB_TYRES} from "../../views/UserViews/TecRmi/MainView";
import {isEmpty} from "lodash";
import {useTranslation} from "react-i18next";

const TyresTab = props => {
  const { t } = useTranslation('tec_rmi');
  const { getApiPrimaryParams, ident } = useTecRmi()
  const [loading, setLoading] = useState(false)
  const [tyres, setTyres] = useState([])
  const [textFilter, setTextFilter] = useState('')

  useDidMountEffect(() => {
    setLoading(true)

    apiUser.tecRmi.tyres.allTyresForType(getApiPrimaryParams())
      .then(res => setTyres(res.data))
      .finally(() => setLoading(false))
  })

  const getData = () => {
    const textFilters = textFilter.split(' ')

    return tyres
      .filter(tyre => {
        if(isEmpty(textFilter)){
          return true
        }

        const textAll = Object.values(tyre).join(' ').toLowerCase()
        return textFilters.filter(textFilter => textAll.indexOf(textFilter.toLowerCase()) >= 0).length === textFilters.length
      })
  }

  return (
    <React.Fragment>
      <BreadcrumbsItem to={appUserRoutes.tecRmi.tab(ident, TAB_TYRES)}>Opony</BreadcrumbsItem>
      {loading && <LoadingSpinner />}
      {!loading && <AppTable
        onSearchQueryChange={setTextFilter}
        columns={[
          {
            dataField: 'FrontRimSize',
            text: t('tyres_tab.table.column.front_rim_size'),
          },
          {
            dataField: 'FrontTyreSize',
            text: t('tyres_tab.table.column.front_tyre_size'),
            headerStyle: {
              width: '140px'
            },
          },
          {
            dataField: 'RearRimSize',
            text: t('tyres_tab.table.column.rear_rim_size'),
          },
          {
            dataField: 'RearTyreSize',
            text: t('tyres_tab.table.column.rear_tyre_size'),
            headerStyle: {
              width: '140px'
            },
          },
          {
            dataField: 'ApplicationText',
            text: t('tyres_tab.table.column.application_text'),
            headerStyle: {
              width: '150px'
            },
          },
          {
            dataField: 'InfoText',
            text: t('tyres_tab.table.column.info_text'),
          },
        ]}
        data={getData()}
      />}
    </React.Fragment>
  );
};

TyresTab.propTypes = {

};

export default TyresTab;